import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { getMeetingTitleByMeeting, getMeetingTitleByMeetingWithDate, getUserFullName2, sortByProperty } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';


function ReportMeetingUsersInfoTable({ data }) {
  const fontSettings = useSelector((state) => state.meeting.fontSettings);
  const { baseFontSize, titleFontSize } = fontSettings;


  data = sortByProperty(data, "type")
  return (
    <>
      <Typography variant="h6" align="center" sx={{ fontSize: titleFontSize }}>
        {data.length > 0 ? getMeetingTitleByMeetingWithDate(data[0]) : ""}
      </Typography>
      <Table size="small" sx={{ borderRadius: 3 }}>
        <TableHead sx={{ backgroundColor: "lightgrey" }}>
          <TableRow>
            <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize }}>Üye Ad Soyad</TableCell>
            <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize }}>Toplantı Rolü</TableCell>
            <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize }}>Katılım Durumu</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize }}>
                {index + 1}. {getUserFullName2(item.title, item.name, item.surname)}{item.acting === "Vekaleten" ? " (V.)" : ""}
              </TableCell>
              <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize }}> {item.type === 1 ? "Üye" : "Katılımcı"}</TableCell>
              <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize, color: item.attendanceStatus === 1 ? 'inherit' : 'error.main' }}>
                {item.attendanceStatus === 1 ? "Katıldı" : "Katılmadı"}
              </TableCell>
            </TableRow>
          ))}
          <TableRow sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
            <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize, fontWeight: 'bold' }}>
              Toplam
            </TableCell>
            <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize, fontWeight: 'bold' }}>
              -
            </TableCell>
            <TableCell align="left" sx={{ width: '33.33%', fontSize: baseFontSize, fontWeight: 'bold' }}>
              Katılan: {data.filter(item => item.attendanceStatus === 1).length} | Katılmayan: {data.filter(item => item.attendanceStatus !== 1).length} | Toplam: {data.length}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}

export default ReportMeetingUsersInfoTable;
